<template>
</template>
<script>

export default {
  name: "verifiedCellphone",
};
</script>